import React, { useState } from "react";
import Search from "./components/search/search-page";

const ErrorBoundary: React.FC = () => {
  return <Search></Search>;
};
export default ErrorBoundary;
